import e from "./index205.mjs";
import t from "./index212.mjs";
function u(r) {
  return t(1, arguments), e(r).getFullYear();
}
export {
  u as default
};
//# sourceMappingURL=index272.mjs.map
